$.plugins.widget = {
	__init: function (config) {
		if (config.label) {
			this.label = $.div().addClass('label').html(config.label).appendTo(this);
		}
		
		if (typeof config.value !== 'undefined') {
			this._field = $.div().addClass('field').appendTo(this);
			this.field = $.div().addClass('value').appendTo(this._field);
			
			if (typeof config.value === 'number') {
				this.field.html(config.value.toString());
			}
			
			else if (typeof config.value === 'string') {
				this.field.html(config.value);
			}
		}
		
		else if (config.label) {
			this.label.addClass(config.type || 'center');
		}
	},
	
	set: function (value) {
		if (this.field) {
			this.field.html(value);
		}
		
		return this;
	},
	
	addMenu: function (config, disabled) {
		var callback = config.callback || function () { return true; };
		
		delete config.callback;
		
		this.menu = $.div().apply('menu', config).appendTo(this);
		
		this.on('click', function (e) {
			if (disabled && game.panel.disabled) {
				return;
			}
			
			var el = e.target;
			
			do {
				if (el.classList.contains('menu')) {
					return;
				}
				
				if (el === this.el) {
					break;
				}
			}
			
			while ((el = el.parentNode) && el && el.classList);
			
			if (el !== this.el) {
				return;
			}
			
			if (callback.call(this) === false) {
				return;
			}
			
			this.menu.toggle();
		});
		
		return this.menu;
	},
};



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/js/widget.js
 **/